const reducer = (state, action) => {
  switch (action.type) {
    case "setLang":
      return {
        ...state,
        lang: action.lang,
      };

    default:
      return state;
  }
};

const initialState = {
  lang: false,
};

export default {
  reducer,
  initialState,
};
